<template>
<standard-dialog v-model="visible" scrollable persistent :width="540">

  <template slot="title">
    <span class="title mr-2">{{data.hostname || data.mac}}</span>
    <span class="caption grey--text">{{data.hostname?data.mac:''}}</span>
  </template>

  <gateway-attributes :data="data" :isDisconnected="isDisconnected" :commands="itemCommands" @toast="val=>$emit('toast',val)"></gateway-attributes>

  <template slot="actions">
    <gateway-menu horizontal :data="data" :optionCommands="optionCommands" @close="visible=false" @toast="val=>$emit('toast',val)" @edit="$emit('edit')"></gateway-menu>
  </template>

</standard-dialog>
</template>

<script>
import Dialog from '@/components/utils/Dialog'
import GatewayItemMenu from './GatewayItemMenu'
import GatewayDetailItemAttributes from './GatewayDetailItemAttributes'

export default {
  name: 'GatewayDetailItem',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      required: true
    },
    optionCommands: {
      type: Object
    },
    itemCommands: {
      type: Object
    }
  },
  components: {
    'standard-dialog': Dialog,
    'gateway-menu': GatewayItemMenu,
    'gateway-attributes': GatewayDetailItemAttributes
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    isDisconnected() {
      let now = new Date().getTime();
      let diff = now - this.data.updatedTime;
      return (diff > 10 * 60 * 1000);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gateway/GatewayDetailItem.vue